export default __webpack_public_path__ + "static/media/download.b39cc4b5.svg";